import React, { useState } from 'react';
import { Container } from 'semantic-ui-react';

const initialForm = {
  name: '',
  email: '',
  message: '',
  company: '',
};

const ContactForm = () => {
  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState('');

  function updateField(event) {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  }

  async function submit(event) {
    event.preventDefault();
    setStatus('sending');
    setError('');

    try {
      const response = await fetch('/++api++/@contact-form', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(form),
      });

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.message || '送信できませんでした。');
      }

      setForm(initialForm);
      setStatus('sent');
    } catch (err) {
      setError(err.message || '送信できませんでした。');
      setStatus('error');
    }
  }

  return (
    <Container className="ehon-contact-page">
      <p className="ehon-kicker">お問い合わせ</p>
      <h1>感想・おすすめ絵本を送る</h1>
      <p className="ehon-lead">
        記事への感想、読んでほしい本、サイトについての連絡はこちらから送れます。
      </p>

      <form className="ehon-contact-form" onSubmit={submit}>
        <label>
          お名前
          <input
            autoComplete="name"
            name="name"
            onChange={updateField}
            required
            type="text"
            value={form.name}
          />
        </label>
        <label>
          メールアドレス
          <input
            autoComplete="email"
            name="email"
            onChange={updateField}
            required
            type="email"
            value={form.email}
          />
        </label>
        <label className="ehon-contact-company">
          会社名
          <input
            autoComplete="off"
            name="company"
            onChange={updateField}
            tabIndex="-1"
            type="text"
            value={form.company}
          />
        </label>
        <label>
          メッセージ
          <textarea
            name="message"
            onChange={updateField}
            required
            rows="8"
            value={form.message}
          />
        </label>
        <button disabled={status === 'sending'} type="submit">
          {status === 'sending' ? '送信中...' : '送信する'}
        </button>
        {status === 'sent' && (
          <p className="ehon-form-success">送信しました。ありがとうございます。</p>
        )}
        {status === 'error' && <p className="ehon-form-error">{error}</p>}
      </form>
    </Container>
  );
};

export default ContactForm;
